import React, {useEffect, useState} from 'react';
import StudentLayout from "@/components/layout/student/studentLayout";
import {Alert, Button, Card, InputNumber, Spin, Statistic} from "antd";
import {Link, useNavigate} from "react-router-dom";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import FreeBox from "@/components/box/freeBox";
import {useApiCreateStudentPaymentGenerate, useApiReadStudentPaymentBalance} from "@/api/payment";
import {toast} from "react-toastify";
import {toFaNumberFormat} from "@/lib/utils/number";
import {urlPath} from "@/lib/utils/url";
import StudentBillingListSection from "@/pages/student/billing/_section/billingListSection";
import {myAcademy} from "@/lib/services/academyService";
import RenderIf from "@/components/render-if";
import {URLS} from "@/lib/urls";
import LowBudgetAlertPay from "@/components/low-budget-alert-pay/LowBudgetAlertPay";
import {useAuth} from "@/provider/AuthProvider";

function StudentBillingPage() {

    const navigate = useNavigate()
    const [lockAccountCharge, setLockAccountCharge] = useState(false)

    const [amount, setAmount] = useState(0)
    const [navigating, setNavigating] = useState(false)

    const {mutate: StartPayment, isPending} = useApiCreateStudentPaymentGenerate();
    const {dashboard} = useAuth();


    const {data: balance, isPending: isPendingBalance} = useApiReadStudentPaymentBalance()

    function handleSubmit() {
        if (amount < 0 || !amount) {
            toast.error("Please enter amount");
            return false;
        }

        StartPayment({
            amount: amount,
            callback_url: urlPath(),
            pay_type: 'online',
            subtype: 'custom_charge_account'

        }, {
            onSuccess: data => {
                ApiHandleSuccessMessage(data)
                if (data?.data?.data?.redirect_url) {
                    setNavigating(true)
                    window.location.href = data?.data?.data?.redirect_url;
                }

            },
            onError: error => {
                ApiHandleErrorMessage(error);
            }
        })
    }

    useEffect(() => {
        if (myAcademy()) {
            setLockAccountCharge(!!myAcademy('lockstudentchargeaccount'))
        }
    })


    return (
        <StudentLayout pageTitle={'بخش مالی'} backTo={URLS.student.dashboard}>
            <LowBudgetAlertPay budget={dashboard?.budget}/>
            <RenderIf condition={balance?.data?.data?.budget > 300000}>
                <Alert
                    showIcon={true}
                    className={'mb-2'} type={'info'} description={<>
                    <div className={'flex flex-wrap gap-2'}>
                        <div className={'flex-1'}>
                            موجودی حساب شما مثبت است.
                            <br/>
                            در صورتی که قصد انتخاب مجدد کلاس را دارید، نیازی به انجام هیچ اقدامی نیست و مبلغ موجود در
                            حساب کاربری شما قابل استفاده خواهد بود.
                            <br/>
                            در غیر این صورت، می‌توانید درخواست بازگشت وجه ثبت کنید تا مبلغ به حساب شخصی شما واریز شود.
                            لطفاً توجه داشته باشید که فرایند بازگشت وجه ممکن است زمان‌بر خواهد بود.
                        </div>
                        <div>
                            <Link to={URLS.student.billing.refund}>
                                <Button type="primary" variant={'dashed'}>
                                    درخواست بازگشت وجه
                                </Button>
                            </Link>

                        </div>
                    </div>

                </>}/>
            </RenderIf>
            <div className="flex flex-wrap gap-2">

                <RenderIf condition={!lockAccountCharge}>
                    <div className={'flex-1'}>
                        <FreeBox>
                            مبلغ شارژ را وارد کنید
                            <div className={'ltr'}>
                                <InputNumber
                                    rootClassName={'ltr text-left'}

                                    step={1000} defaultValue={1000}
                                    className={'w-full'}
                                    type="number"
                                    changeOnWheel={false}
                                    onPressEnter={() => handleSubmit()}
                                    min={1000}

                                    addonAfter={<span>تومان</span>}
                                    max={10000000}
                                    value={amount}
                                    onChange={(e) => setAmount(e)}
                                />
                            </div>


                            <Button
                                loading={isPending}
                                onClick={() => handleSubmit()} className={'mt-2'} type="primary" htmlType="submit">
                                شارژ حساب
                            </Button>
                            {navigating &&
                                <span><Spin size={'small'} className={'mx-2'} spinning={true}/>در حال انتقال به درگاه بانک ...</span>}
                        </FreeBox>
                    </div>
                </RenderIf>

                <div className={'flex-1 justify-center text-center'}>

                    <Card variant="borderless">
                        <Statistic
                            title="شارژ حساب شما"
                            value={balance?.data?.data?.budget}
                            loading={isPendingBalance}
                            formatter={(value) => toFaNumberFormat(value)}
                            precision={0}
                            valueStyle={{color: balance?.data?.data?.budget < 0 ? 'red' : 'green'}}

                            suffix="تومان"
                        />
                    </Card>


                </div>
            </div>

            <StudentBillingListSection/>


        </StudentLayout>
    );
}

export default StudentBillingPage;


